<template>
  <p></p>
</template>
<style lang="less" type="text/less"></style>
<script>
import { getCookie } from '@/assets/utils/CommonUtil'
export default {
  name: 'HomeIndex',
  created () {
    const role = getCookie('role')
    // let path = '/project/joined/list'
    let path = '/workbench/index'
    switch (+role) {
      case 1: // 管理员
        path = '/manage/members'
        break
      // case 2: // 总负责人
      //   path = '/project/all/list'
      //   break
      case 6:
        path = '/manage/records'
        break
      case 5: // 个人账号
        path = '/space/files/list'
        break
      default: // 3: 档案室负责人, 4: 普通员工
    }
    const grayDomain = getCookie('grayMenuDomain')
    if (typeof grayDomain === 'string' && grayDomain.includes('cfmcc')) {
      path = '/cfmcc/budget'
    }
    if (path) {
      setTimeout(() => {
        this.$router.replace({ path })
      }, 100)
    }
    // path && this.$router.replace({ path })
  }
}
</script>
